// Lazy chunk factories keyed by canonical menu key.
// Each entry is a `() => import(...)` — calling it kicks off the chunk download
// and returns the same promise (webpack caches it). We use this from both
// React.lazy (in App.js) and the sidebar hover prefetch (in Layout.jsx) so
// hovering a link starts the download before the click.
export const CHUNK_FACTORIES = {
  dashboard:   () => import("@/pages/Dashboard"),
  packages:    () => import("@/pages/PackagesList"),
  pipeline:    () => import("@/pages/Kanban"),
  templates:   () => import("@/pages/Templates"),
  quick_quote: () => import("@/pages/QuickQuote"),
  customers:   () => import("@/pages/Customers"),
  vendors:     () => import("@/pages/Vendors"),
  hotels:      () => import("@/pages/Hotels"),
  reports:     () => import("@/pages/Reports"),
  users:       () => import("@/pages/Users"),
  audit_log:   () => import("@/pages/AuditLog"),
  settings:    () => import("@/pages/Settings"),
  referrers:   () => import("@/pages/Referrers"),
  my_referrals: () => import("@/pages/ReferrerDashboard"),
  master_data: () => import("@/pages/MasterData"),
  package_editor: () => import("@/pages/PackageEditor"),
};

// Track which keys have already been prefetched to avoid re-invocation on every hover
const prefetched = new Set();

export const prefetchRoute = (menuKey) => {
  if (!menuKey || prefetched.has(menuKey)) return;
  const fn = CHUNK_FACTORIES[menuKey];
  if (!fn) return;
  prefetched.add(menuKey);
  // Fire-and-forget; webpack will cache the promise so React.lazy resolves instantly on click
  fn().catch(() => prefetched.delete(menuKey));   // let it retry on failure
};
